import { render, staticRenderFns } from "./QuotationDownload.vue?vue&type=template&id=2e32380b"
import script from "./QuotationDownload.vue?vue&type=script&lang=js"
export * from "./QuotationDownload.vue?vue&type=script&lang=js"
import style0 from "./QuotationDownload.vue?vue&type=style&index=0&id=2e32380b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports